    export function initSimpleNavigation() {
        var navigation = document.querySelector(".block--simple-navigation");

        if (!navigation) {
            return;
        }
        var toggle = navigation.querySelector(".simple-navigation__mobile-toggle");
        var menu = navigation.querySelector(".simple-navigation__mobile");

        if (!toggle || !menu) {
            return;
        }

        var closeMenu = function () {
            toggle.setAttribute("aria-expanded", "false");
            menu.hidden = true;
            navigation.classList.remove("is-open");
        };

        var openMenu = function () {
            toggle.setAttribute("aria-expanded", "true");
            menu.hidden = false;
            navigation.classList.add("is-open");
        };

        toggle.addEventListener("click", function () {
            var isOpen = toggle.getAttribute("aria-expanded") === "true";

            if (isOpen) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        menu.addEventListener("click", function (event) {
            var clickedLink = event.target && event.target.closest && event.target.closest("a");

            if (clickedLink) {
                closeMenu();
            }
        });

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
                closeMenu();
                toggle.focus();
            }
        });

        var desktopMediaQuery = window.matchMedia("(min-width: 768px)");
        var onDesktopChange = function (event) {
            if (event.matches) {
                closeMenu();
            }
        };

        if (desktopMediaQuery.addEventListener) {
            desktopMediaQuery.addEventListener("change", onDesktopChange);
        } else if (desktopMediaQuery.addListener) {
            desktopMediaQuery.addListener(onDesktopChange);
        }
    }
